import { render, staticRenderFns } from "./devicesDetails.vue?vue&type=template&id=356a936b&scoped=true"
import script from "./devicesDetails.vue?vue&type=script&lang=js"
export * from "./devicesDetails.vue?vue&type=script&lang=js"
import style0 from "./devicesDetails.vue?vue&type=style&index=0&id=356a936b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a936b",
  null
  
)

export default component.exports